<div
  class="tools-bar"
  #toolsBar
  [ngStyle]="{ left: left$() + 'px' }"
  cdkDrag
  [cdkDragBoundary]="mapBoundary"
>
  <div cdkDragHandle class="grab-button">
    <button matIconButton aria-label="Grab" matTooltip="Grab to move bar">
      <mat-icon>drag_indicator</mat-icon>
    </button>
  </div>

  <div class="buttons">
    <app-selection-tool></app-selection-tool>

    <span class="divider"></span>

    @if (isLoggedIn$()) {
      <div>
        <button
          matIconButton
          aria-label="Save snapshot"
          matTooltip="Save snapshot"
          (click)="addSnapshot()"
          [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
        >
          <mat-icon class="material-symbols-outlined">screenshot_region</mat-icon>
        </button>

        <!-- Enabled access to list of layer only if all layers loaded -->
        <button
          matIconButton
          aria-label="Select a snapshot"
          matTooltip="Select a snapshot"
          (click)="openMySnapshots()"
          [disabled]="
            this.personalLayersState$().status !== 'success' ||
            this.sharedLayersState$().status !== 'success' ||
            calculationModuleService.isCMRunning$() ||
            scenarioService.isDataLoading$()
          "
        >
          <mat-icon class="material-symbols-outlined">frame_reload</mat-icon>
        </button>

        <span class="divider"></span>
      </div>
    }

    <mat-button-toggle-group
      name="backgroundMap"
      aria-label="Background map"
      value="Satellite"
      [hideSingleSelectionIndicator]="true"
      (change)="changeBackgroundMap($event)"
    >
      <mat-button-toggle value="Satellite" matTooltip="Satellite"
        ><mat-icon>public</mat-icon></mat-button-toggle
      >
      <mat-button-toggle value="Road" matTooltip="Road">
        <mat-icon>language</mat-icon></mat-button-toggle
      >
    </mat-button-toggle-group>

    <select
      matNativeControl
      class="select-scale-levels"
      id="selectSelectableAreas"
      matTooltip="Selectable areas"
      (change)="changeSelectableAreas()"
      [disabled]="calculationModuleService.isCMRunning$() || scenarioService.isDataLoading$()"
    >
      <!-- @todo, manage options for scale level dropdown -->
      @for (scaleLevel of selectionScaleService.scaleLevels; track scaleLevel) {
        <option
          [selected]="
            scaleLevel.displayName == selectionScaleService.currentScaleLevel$()?.displayName
          "
          [value]="scaleLevel.displayName"
        >
          {{ scaleLevel.displayName }}
        </option>
      }
    </select>
  </div>
</div>
